import { useNavigate } from 'react-router';
import { AuthApi } from '../../../api';
import { LocalStorage } from '../../../util/LocalStorage';
import { useContainer } from '../../useContainer';
import { userInitialState } from '../../../store/slices/auth.slice';
import { useAddAuth } from '../useAddAuth';

const useHttpPostAuthUserNoRoleCheck = () => {
    const authApi: AuthApi = useContainer(AuthApi);
    const storage: LocalStorage = useContainer(LocalStorage);
    const navigate = useNavigate();
    const { addUserAuth } = useAddAuth();

    const { exec } = authApi.authNoRoleCheck({
        onSuccess: res => addUserAuth(res.body),
        onError: _ => {
            addUserAuth(userInitialState.value);
            storage.removeAuth();
            navigate('/sign-up');
        },
    });

    return { exec };
};

export default useHttpPostAuthUserNoRoleCheck;
